// extracted by mini-css-extract-plugin
export default {"root":"ComingSoonData_root__esk8q","dataList":"ComingSoonData_dataList__VJY3I","title":"ComingSoonData_title__cdYIo"};